import { defineStore } from "pinia";
import { authUrl, post, site_name } from "../services/apiReq.js";
import axios from "axios";
import { clear, getObject, saveObject } from "../services/storage.js";
import { show } from "../services/notification.js";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null,
  }),
  getters: {},
  actions: {
    async login(email, password) {
      clear();
      let response = await axios.post(authUrl + "/login", {
        email,
        password,
        site_name,
        panel: 0,
      });
      const { User, message } = response.data;
      let user = User;
      if (message) {
        show(response.data.message);
      }
      if (user) {
        this.user = user;
        saveObject("user", user);
        return true;
      }
      return false;
    },
    logout() {
      clear();
      location.reload();
    },
    async get() {
      // || Api request
      let _user = getObject("user");
      if (!_user) return;
      else {
        let response = await axios.post(authUrl + "/user", _user);
        _user = response.data?.user;
        if (_user) {
          this.user = _user;
          saveObject("user", _user);
        }
      }
    },
    async getUser() {
      if (!this.user) {
        await this.get();
      }
      return this.user;
    },
  },
});
